var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-cache',{ref:"cache",attrs:{"get-data":_vm.getUser,"id":this.$route.query.id},scopedSlots:_vm._u([{key:"default",fn:function({data}){return [_c('user-details-edit',{attrs:{"data":data,"status":"edit"},on:{"refresh":function($event){return _vm.refresh()}}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }